module.exports = __webpack_public_path__ + "8700caa130e87af3d6c687dec522c2b1.png";